"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon_1 = __importStar(require("../Icon"));
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search(props) {
        var _this = _super.call(this, props) || this;
        /* eslint-disable-next-line @typescript-eslint/naming-convention */
        _this._ignoreBlur = false;
        _this.onFocus = function () {
            _this.ignoreBlur(false);
        };
        _this.onChange = function (e) {
            var value = e.currentTarget.value;
            _this.setState({ value: value });
        };
        _this.onClick = function () {
            if (_this.props.onSelected) {
                _this.props.onSelected(_this.state.value);
            }
        };
        _this.onBlur = function () {
            if (_this._ignoreBlur) {
                return;
            }
            // Reset state on blur if value was not sent.
            if (_this.props.value !== _this.state.value) {
                _this.setState({ value: _this.props.value });
            }
        };
        _this.onMouseDown = function () {
            _this.ignoreBlur(true);
        };
        _this.onKeyPress = function (e) {
            if (e.key === "Enter") {
                _this.onClick();
            }
        };
        _this.state = {
            value: props.value,
            prevPropsValue: props.value,
        };
        return _this;
    }
    Search.getDerivedStateFromProps = function (props, state) {
        if (state.prevPropsValue !== props.value) {
            return {
                value: props.value,
                prevPropsValue: props.value,
            };
        }
        return null;
    };
    Search.prototype.ignoreBlur = function (ignore) {
        this._ignoreBlur = ignore;
    };
    Search.prototype.render = function () {
        var value = this.state.value;
        var size = this.props.size;
        return (react_1.default.createElement("div", { className: "respect__input_div" },
            react_1.default.createElement("input", { type: "text", size: size, value: value, onFocus: this.onFocus, onBlur: this.onBlur, onChange: this.onChange, onKeyPress: this.onKeyPress, className: "respect__input with_stop_icon" }),
            react_1.default.createElement("div", { onMouseDown: this.onMouseDown, onClick: this.onClick },
                react_1.default.createElement(Icon_1.default, { icon: Icon_1.IconType.Search, style: { cursor: "pointer" }, className: "icon_stop" }))));
    };
    return Search;
}(react_1.default.Component));
exports.default = Search;
//# sourceMappingURL=Search.js.map